import { createContext, useContext, useRef } from "react";

const ReportDateContext = createContext(null);

export const ReportDateProvider = ({ children }) => {
  const sharedDateRef = useRef(null);
  return (
    <ReportDateContext.Provider value={sharedDateRef}>
      {children}
    </ReportDateContext.Provider>
  );
};

export const useReportDateContext = () => useContext(ReportDateContext);
